<template>
	<div class="product">
		<div class="img-box">
			<img src="../../assets/imgs/pruduct-top.jpg" alt="" />
		</div>
		<div class="product-content">
			<!-- 左侧导航栏区域 -->
			<div v-loaction class="product-content-left">
				<self-menu
					:menuList="menuList"
					:props="defaultProps"
					activeLabel="id"
					:active="active"
					@selected="selected"
				></self-menu>
			</div>
			<!-- 右侧产品图片区域 -->
			<el-row :gutter="10">
				<el-col
					v-for="(d, i) in productList"
					:key="i"
					:xs="12"
					:sm="8"
					:md="6"
					:lg="6"
					:xl="6"
					><div class="grid-content">
						<img
							@click="gotoDetails(d)"
							v-lazy="`${$queryUrl}${d.productImage}`"
							alt=""
						/>
						<div class="product-top" :title="d.productName">
							{{ d.productName }}
						</div>
						<el-button @click="gotoDetails(d)" type="primary">
							{{ $t("seeMore") }}
							<!-- <router-link :to="'/product/' + d.productType"
                >查看更多</router-link
              > -->
						</el-button>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import menu from "../../components/Menus";

export default {
	components: { selfMenu: menu },
	directives: {
		// 设置页面滚动时左侧菜单栏的位置变化
		loaction: {
			bind(el) {
				window.addEventListener("scroll", function() {
					let scrollTop =
						document.documentElement.scrollTop ||
						document.body.scrollTop;
					if (scrollTop < 280) {
						el.style.top = 420 - scrollTop + "px";
					} else if (scrollTop > 280) {
						el.style.top = "150px";
					}
				});
			},
		},
	},
	data() {
		return {
			menuList: [],
			defaultProps: {
				children: "childMenus",
				label: "name",
			},
			query: null,
			productList: [],
			active: "1",
		};
	},
	created() {
		console.log(this.$route.query);
		this.query = this.$route.query;
		console.log(this.query);

		this.getMenu();
	},
	methods: {
		getMenu() {
			if(this.query === 'undefined'){
				this.$axios.post(`selectProductCategoriesInfo`).then((res) => {
					if (res.data.code === "0") {
						this.menuList = res.data.data;
						let params = {
							categoriesName: this.menuList[0]
								.productCategoriesList[0].categoriesName,
							categoriesName1: this.menuList[0]
								.productCategoriesList[0].categoriesName1,
							productType: this.menuList[0].productCategoriesList[0]
								.name,
						};
						this.getProductList(params);
					} else {
						this.$message({
							message: res.data.errorMessage,
							type: "warning",
						});
					}
				});
			}else{
					let params = {
							categoriesName: this.query.categoriesName,
							categoriesName1: this.query.categoriesName1,
							productType: this.query.productType,
					};
					
					this.getProductList(params);

					this.$axios.post(`selectProductCategoriesInfo`).then((res) => {
						// for (let index = 0; index < res.data.length; index++) {
						// 	const element = res.data[index];
						// 	const name = element.name;
						// 	if(name === params.productType)[
								
						// 	]
							
						// }
						if (res.data.code === "0") {
							this.menuList = res.data.data;
						} else {
							this.$message({
								message: res.data.errorMessage,
								type: "warning",
							});
						}
					});
				// 	this.$axios.post(`selectProductCategoriesInfo`).then((res) => {
				// 	if (res.data.code === "0") {
				// 		this.menuList = res.data.data;
				// 		let params = {
				// 			categoriesName: this.menuList[0]
				// 				.productCategoriesList[0].categoriesName,
				// 			categoriesName1: this.menuList[0]
				// 				.productCategoriesList[0].categoriesName1,
				// 			productType: this.menuList[0].productCategoriesList[0]
				// 				.name,
				// 		};
				// 		this.getProductList(params);
				// 	} else {
				// 		this.$message({
				// 			message: res.data.errorMessage,
				// 			type: "warning",
				// 		});
				// 	}
				// });
				}
		},
		getProductList(params) {
			this.$axios.post(`selectProductShowInfo`, params).then((res) => {
				this.productList = res.data.data;
			});
		},
		gotoDetails(d) {
			this.$router.push({
				name: "productDetails",
				params: { id: d.productName },
				query: d,
			});
		},
		selected(data) {
			this.active = data.id;
			let params = {
				categoriesName: data.productCategoriesList[0].categoriesName,
				categoriesName1: data.productCategoriesList[0].categoriesName1,
				productType: data.productCategoriesList[0].productType,
			};
			this.getProductList(params);
		},
	},
};
</script>
<style lang="scss">
.product {
	.product-header-img {
		img {
			width: 100%;
			max-height: 236px;
		}
	}
	.img-box {
		img {
			height: 400px;
			width: 100%;
		}
	}
	.product-content {
		display: flex;
		flex-direction: row;
		width: 1200px;
		margin: 0 auto;
		flex: 1;
		margin-bottom: 60px;
		.product-content-left {
			border: 1px solid #ccc;
			box-sizing: border-box;
			width: 200px;
			margin-top: 6px;
			// position: absolute;
			.el-tree {
				width: 100%;
			}
		}
		.el-row {
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			margin: 0 !important;
			.grid-content {
				box-shadow: 0 0px 5px rgba(0, 0, 0, 0.1);
				margin: 6px 0;
				text-align: center;
				overflow: hidden;
				img {
					max-width: 100%;
					height: 230px;
					cursor: pointer;
					&:hover {
						transform: scale(1.1);
					}
				}
			}
			.product-top {
				line-height: 40px;
				font-size: 14px;
				text-align: center;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				padding: 0 12px;
			}
			.product-bottom {
				line-height: 22px;
				font-size: 12px;
				text-align: center;
			}
			.el-button {
				width: 100%;
				border-radius: 0;
				margin-top: 8px;
				span,
				a {
					display: inline-block;
					width: 100%;
					height: 100%;
					color: #fff;
				}
			}
		}
		// img {
		//   width: auto;
		//   height: auto;
		// }
	}
}
</style>
